module.exports = __webpack_public_path__ + "static/media/sapo-barriga-vermelha_thumb.33def527.jpg";